import React, { useEffect } from "react";
import SingleSelectBox from "../../../FormComponents/SingleSelectBox";
import Input from "../../../FormComponents/Input";
import FieldSelectorFromPopup from "../../FieldSelectorFromPopup";
import MaterialIcon from "../../MaterialIcon";
import Button from "../../../FormComponents/Button";

const StopJob = ({ params, editJobData, setParams, tableId, tableType, readOnly, preRequirements, keyName }) => {
  useEffect(() => {
    if (editJobData?.params?.[keyName]) {
      setParams((prev) => ({
        ...prev,
        [keyName]: editJobData.params[keyName]
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params[preRequirements[preRequirements.indexOf(keyName) - 1]]]);

  if (readOnly) {
    return <StopJobReadOnly params={params} />;
  }

  const operatorOptions = [
    { id: "empty", name: "Empty" },
    { id: "==", name: "Equals (==)" },
    { id: "equals_ignore_case", name: "Equals (Ignore Case)" },
    { id: "contains_str", name: "Contains (Case Sensitive)" },
    { id: "contains_str_ignore_case", name: "Contains (Ignore Case)" },
    { id: "!=", name: "Not Equals (!=)" },
    { id: ">", name: "Greater Than (>)" },
    { id: "<", name: "Less Than (<)" },
    { id: ">=", name: "Greater Than or Equal (>=)" },
    { id: "<=", name: "Less Than or Equal (<=)" },
    { id: "in", name: "In (Array/Map)" },
    { id: "contains", name: "Contains (Array)" },
    { id: "intersects", name: "Intersects (Arrays)" },
    { id: "subset", name: "Subset (Arrays)" }
  ];

  const typeOptions = [
    { id: "http-data", name: "http-data" },
    { id: "mapped", name: "mapped" }
  ];

  const handleConditionChange = (index, field, value) => {
    const updatedConditions = [...(params?.condition_mapping || [])];
    updatedConditions[index] = {
      ...updatedConditions[index],
      [field]: value
    };

    // If type changes, reset compareValue
    if (field === "type") {
      updatedConditions[index].compareValue = "";
    }

    setParams({
      ...params,
      condition_mapping: updatedConditions
    });
  };

  const handleAddCondition = () => {
    const newCondition = {
      compareValue: "",
      operator: "==",
      value: "",
      type: "http-data",
      message: ""
    };

    setParams({
      ...params,
      condition_mapping: [...(params?.condition_mapping || []), newCondition]
    });
  };

  const handleRemoveCondition = (index) => {
    const updatedConditions = (params?.condition_mapping || []).filter((_, i) => i !== index);
    setParams({
      ...params,
      condition_mapping: updatedConditions
    });
  };

  const renderCompareValueInput = (condition, index) => {
    return (
      <Input
        value={condition.compareValue || ""}
        onChange={(e) => handleConditionChange(index, "compareValue", e.target.value)}
        placeholder="Enter compare value"
        inputBoxStyle={{ maxWidth: "none" }}
      />
    );
  };

  const renderValueInput = (condition, index) => {
    if (condition.type === "mapped") {
      return (
        <FieldSelectorFromPopup
          tableId={tableId}
          tableType={tableType}
          onSelect={(field) => handleConditionChange(index, "value", field.id)}
          fieldId={condition.value}
          label="Select Field"
        />
      );
    } else {
      return (
        <Input
          value={condition.value || ""}
          onChange={(e) => handleConditionChange(index, "value", e.target.value)}
          placeholder="Enter value"
          inputBoxStyle={{ maxWidth: "none" }}
        />
      );
    }
  };

  // Check if operator needs value field
  // const needsValueField = (operator) => {
  //   return operator !== "empty";
  // };

  const conditions = params?.condition_mapping || [];

  return (
    <div className="builder_form mt_2">
      <div className="d_flex justify_between align_center mb_3">
        <label className="builder_label">Condition Mapping</label>
        <Button type="button" onClick={handleAddCondition} style={{ padding: "6px 16px", fontSize: "13px" }}>
          <MaterialIcon name="add" style={{ fontSize: "18px", marginRight: "4px" }} />
          Add Condition
        </Button>
      </div>

      {conditions.length > 0 ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {conditions.map((condition, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                backgroundColor: "#ffffff"
              }}
            >
              {/* Header */}
              <div
                style={{
                  backgroundColor: "#f3f4f6",
                  padding: "10px 16px",
                  borderBottom: "1px solid #d1d5db",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <span style={{ fontWeight: "600", fontSize: "13px", color: "#374151" }}>Condition {index + 1}</span>
                <MaterialIcon
                  name="delete"
                  className="cursor_pointer"
                  onClick={() => handleRemoveCondition(index)}
                  style={{ color: "#dc2626", fontSize: "20px" }}
                />
              </div>

              {/* Content */}
              <div style={{ padding: "16px" }}>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "16px" }}>
                  {/* Type */}
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: "12px",
                        fontWeight: "600",
                        marginBottom: "6px",
                        color: "#374151"
                      }}
                    >
                      Type
                    </label>
                    <SingleSelectBox
                      options={typeOptions}
                      valueKey="id"
                      labelKey={["name"]}
                      selectedData={condition.type || "http-data"}
                      onChange={(option) => handleConditionChange(index, "type", option.id)}
                      placeholder="Select type"
                    />
                  </div>

                  {/* Operator */}
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: "12px",
                        fontWeight: "600",
                        marginBottom: "6px",
                        color: "#374151"
                      }}
                    >
                      Operator
                    </label>
                    <SingleSelectBox
                      options={operatorOptions}
                      valueKey="id"
                      labelKey={["name"]}
                      selectedData={condition.operator || "=="}
                      onChange={(option) => handleConditionChange(index, "operator", option.id)}
                      placeholder="Select operator"
                    />
                  </div>

                  {/* Value */}
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: "12px",
                        fontWeight: "600",
                        marginBottom: "6px",
                        color: "#374151"
                      }}
                    >
                      Value
                    </label>
                    {renderValueInput(condition, index)}
                  </div>

                  {/* Compare Value */}
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: "12px",
                        fontWeight: "600",
                        marginBottom: "6px",
                        color: "#374151"
                      }}
                    >
                      Compare Value
                    </label>
                    {renderCompareValueInput(condition, index)}
                  </div>

                  {/* Message - Full Width */}
                  <div style={{ gridColumn: "1 / -1" }}>
                    <label
                      style={{
                        display: "block",
                        fontSize: "12px",
                        fontWeight: "600",
                        marginBottom: "6px",
                        color: "#374151"
                      }}
                    >
                      Message
                    </label>
                    <Input
                      value={condition.message || ""}
                      onChange={(e) => handleConditionChange(index, "message", e.target.value)}
                      placeholder="Enter custom message"
                      inputBoxStyle={{ maxWidth: "none" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div
          style={{
            padding: "40px 20px",
            textAlign: "center",
            color: "#9ca3af",
            border: "2px dashed #e5e7eb",
            borderRadius: "6px",
            backgroundColor: "#f9fafb"
          }}
        >
          <MaterialIcon name="rule" style={{ fontSize: "48px", marginBottom: "8px", opacity: 0.5 }} />
          <div style={{ fontSize: "14px", fontWeight: "500" }}>No conditions added</div>
          <div style={{ fontSize: "12px", marginTop: "4px" }}>Click "Add Condition" to create your first condition</div>
        </div>
      )}
    </div>
  );
};

const StopJobReadOnly = ({ params }) => {
  const conditions = params?.condition_mapping || [];

  if (conditions.length === 0) {
    return (
      <div className="builder_form mt_2">
        <label className="builder_label">Condition Mapping</label>
        <div style={{ padding: "20px", textAlign: "center", color: "#667085" }}>No conditions configured</div>
      </div>
    );
  }

  return (
    <div className="builder_form mt_2">
      <label className="builder_label">Condition Mapping</label>
      <table className="post_activity_sidebar_table" style={{ marginTop: "12px" }}>
        <thead>
          <tr>
            <th style={{ width: "100px" }}>Condition</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {conditions.map((condition, index) => (
            <tr key={index}>
              <td style={{ verticalAlign: "top", fontWeight: "600", color: "#374151" }}>{index + 1}</td>
              <td style={{ padding: "8px" }}>
                <table style={{ width: "100%", border: "none" }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          width: "150px",
                          fontWeight: "500",
                          color: "#6b7280",
                          border: "none",
                          padding: "4px 8px"
                        }}
                      >
                        Type:
                      </td>
                      <td style={{ border: "none", padding: "4px 8px" }}>{condition.type || "-"}</td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          width: "150px",
                          fontWeight: "500",
                          color: "#6b7280",
                          border: "none",
                          padding: "4px 8px"
                        }}
                      >
                        Value:
                      </td>
                      <td style={{ border: "none", padding: "4px 8px" }}>{condition.value || "-"}</td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          width: "150px",
                          fontWeight: "500",
                          color: "#6b7280",
                          border: "none",
                          padding: "4px 8px"
                        }}
                      >
                        Operator:
                      </td>
                      <td style={{ border: "none", padding: "4px 8px" }}>{condition.operator || "-"}</td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          width: "150px",
                          fontWeight: "500",
                          color: "#6b7280",
                          border: "none",
                          padding: "4px 8px"
                        }}
                      >
                        Compare Value:
                      </td>
                      <td style={{ border: "none", padding: "4px 8px" }}>{condition.compareValue || "-"}</td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          width: "150px",
                          fontWeight: "500",
                          color: "#6b7280",
                          border: "none",
                          padding: "4px 8px"
                        }}
                      >
                        Message:
                      </td>
                      <td style={{ border: "none", padding: "4px 8px" }}>{condition.message || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StopJob;
export { StopJobReadOnly };
